import * as React from 'react'
import SiderbarCom from './siderbar'
import './index.less'
import { storage } from '@/utils/tools'
import { USER_INFO } from '@/constants'
import { AdminRoutes } from '@/routes/pageRoute'


class Home extends React.Component {

  constructor(props) {
    super(props)
    const userInfo = storage.get(USER_INFO)
    if(userInfo) {
      this.state.userInfo =  JSON.parse(userInfo)
    }
  }

  state = {
    authorized: true,
    userInfo: {
      name: ''
    }
  }

  componentDidMount() {
    // 
  }

  render() {
    const { authorized, userInfo } = this.state

    return (
      <div className="admin-bg">
        <div id="admin-page">
          <div id="left-content">
            <SiderbarCom/>
          </div>
          <div id="right-content">
            <div className="breadcrumb">
              {/* <p>admin page content</p> */}
            </div>  
            <div id="main-content">
              { AdminRoutes(authorized) }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Home